import { render, staticRenderFns } from "./get-all-withdrawal-details.vue?vue&type=template&id=b6f5371e&scoped=true&"
import script from "./get-all-withdrawal-details.vue?vue&type=script&lang=js&"
export * from "./get-all-withdrawal-details.vue?vue&type=script&lang=js&"
import style0 from "./get-all-withdrawal-details.vue?vue&type=style&index=0&id=b6f5371e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f5371e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/kolobox-admin/kolobox-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VAlert,VApp,VBtn,VCard,VCardTitle,VContainer,VDataTable,VFlex,VLayout,VSpacer,VTextField})
